import React, { Component } from "react";
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import LinesEllipsis from 'react-lines-ellipsis'
import 'moment/locale/ru';

import "./PollItem.scss";
import { getWordEnding } from "../../../../methods";

class PollItem extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    onClickPoll: PropTypes.func.isRequired,
    onRestore: PropTypes.func.isRequired,
  };

  onClickPollItem = (id, status) => {
    const { onClickPoll } = this.props;
    if (status === 'ENABLED') onClickPoll(id);
  }

  render() {
    const { poll, onRestore } = this.props;

    if (poll.status === 'DISABLED') poll.isClosed = true;
    else poll.isClosed = false;
    
    const pollClass = classnames({ 
      'list-item-main': true,
      'closed': poll.isClosed,
    });

    return (
      <div className={pollClass} onClick={() => this.onClickPollItem(poll.id, poll.status)}>
        <div className="list-item-title">
          <LinesEllipsis
            text={poll.text}
            maxLine='2'
            ellipsis='...'
            trimRight
            basedOn="letters"
            className="title"
          />
        </div>
        {poll.isClosed ? (
          <div className="list-item-content closed">
            <div className="closed-text">Опрос скрыт</div>
            <button type="button" className="btn btn-black" onClick={() => onRestore(poll.id)}>Восстановить</button>
          </div>
        ) : (
          <div className="list-item-content"> 
            <div className="poll-voted-date">
              <div className="poll-voted">
                {poll.vote_count} {getWordEnding(poll.vote_count, ['человек', 'человека', 'человек'])}
              </div>
              <div className="poll-date">{moment(poll.created_at).locale('ru').format('LL HH:mm')}</div>
            </div>
            <div className="list-item-for">
              {((poll.type === 'CONSULTANTS') || (poll.type === 'ALL')) ? 
                (<div className="for-item consultants">Консультанты</div>)
               : false}
              {((poll.type === 'CLIENTS') || (poll.type === 'ALL')) ? 
                (<div className="for-item clients">Клиенты</div>)
               : false}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PollItem;
